module.exports = __webpack_public_path__ + "static/media/slider3.2c08ed8a.png";